/**
 * WordPress dependencies
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import Edit from './edit';

/**
 * Block metadata
 */
import metadata from './block.json';

/**
 * Register the Before & After Photos block
 */
registerBlockType(metadata.name, {
	edit: Edit,
}); 